import axiosInstance from './Instance/axiosInstance';

export const fetchPermissions = async () => {
    const res = await axiosInstance.get('/permissions');
    return res.data.perms;
};